import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';
import Audio from '../shared/audio';

function VoicesList(props) {
  return (
    <Table striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center'>مرجع</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>عنوان</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>فایل</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.voices.map(voice => (
          <Table.Row key={voice.id}>
            <Table.Cell textAlign='center'>{voice.referenceItem.repr}</Table.Cell>
            <Table.Cell textAlign='center'>{voice.name}</Table.Cell>
            <Table.Cell textAlign='center'>
              <Audio src={`${process.env.REACT_APP_VOICE_BASE_URL}/${voice.file}`}/>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
}

VoicesList.propTypes = {
  voices: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default VoicesList;
